import { createTheme } from '@mui/material/styles';
import { COLOR_PRIMARY } from 'src/const';

const theme = createTheme({
  typography: {
    button: {
      textTransform: 'none',
    },
    h1: {
      fontSize: '20px',
      color: '#primaryColor',
      fontWeight: 500,
    },
    h2: {
      fontSize: '18px',
      color: '#primaryColor',
      fontWeight: 500,
    },
  },
  palette: {
    primary: {
      main: COLOR_PRIMARY,
    },
  },
});

export default theme;
